/**
 * 下单类型
 * 1、正常下单 2.一元购 3.秒杀 4.拼团 5.积分兑换 6：分销 7：立减 8：满赠/赠品 9:扫码付 11:自营摄影扫码付 999返现 12:参与了X元购活动
 * 返现由于服务端没有返回类型 这里加一个999 返卷使用998 防止后面重复
 */
export const E_PROMOTION_TYPE = {
  POSITIVE_PRICE: 1,
  ONE_YUAN_PURCHASE: 2,
  FLASH_SALE: 3,
  GROUP_BUY: 4,
  CREDITS_EXCHANGE: 5,
  DISTRIBUTION: 6,
  DISCOUNT: 7,
  REWARD_GIFT: 8,
  RETURN_CASH: 999,
  RETURN_COUPON: 998,
  SCAN_BUY: 9,
  SCAN_BUY_PHOTO: 11,
  XBUY_EVENT: 12
}
/**
 * 下单类型
 * 1、正常下单 2.一元购 3.秒杀 4.拼团 5.积分兑换 6：分销 7：立减 8：满赠/赠品 9:扫码付
 */
export const E_ORDER_TYPE = E_PROMOTION_TYPE

export const PROMOTION_TYPES = new Map([
  [E_PROMOTION_TYPE.POSITIVE_PRICE, '正价'],
  [E_PROMOTION_TYPE.ONE_YUAN_PURCHASE, '一元购'],
  [E_PROMOTION_TYPE.FLASH_SALE, '秒杀'],
  [E_PROMOTION_TYPE.GROUP_BUY, '拼团'],
  [E_PROMOTION_TYPE.CREDITS_EXCHANGE, '积分兑换'],
  [E_PROMOTION_TYPE.DISTRIBUTION, '分销'],
  [E_PROMOTION_TYPE.DISCOUNT, '立减'],
  [E_PROMOTION_TYPE.REWARD_GIFT, '赠品'],
  [E_PROMOTION_TYPE.RETURN_CASH, '返现'],
  [E_PROMOTION_TYPE.RETURN_COUPON, '返券'],
  [E_PROMOTION_TYPE.XBUY_EVENT, '特惠']
])

/**
 * 101:游乐 201:摄影 301:活动 401:育儿 501:班课 502:一对一 503:音频 504:视频 601:门票
 */
export const SKU_TYPE = new Map([
  [101, '游乐'],
  [201, '摄影'],
  [301, '活动'],
  [401, '育儿'],
  [402, '育儿'],
  [501, '班课'],
  [502, '一对一'],
  [503, '音频'],
  [504, '视频'],
  [601, '门票']
])
/**
 * 新签月嫂标识
 */
export const YUESAO_ID = '10112210'
export const YUESAO_LEVEL4_CATEGORY_ID = ['10112212', '10112210']
/**
 * 联营月嫂标识
 */
export const UNION_YUESAO_ID = '10112211'

/**
 * 新签月嫂标识
 */
export const NEW_SIGNED_YUESAO_ID = 4

/**
 * SKU标签类型(订单信息组件控制字段orderStyleTag更合适)
 * @enum {number}
 */
export const E_SKUTAG = {
  /**
   * 自营到店
   */
  SELFSTORE: 1,
  /**
   * 自营到家
   */
  SELFHOME: 2,
  /**
   * pop-月嫂,即联营月嫂
   */
  POPYUSAO: 3,
  /**
   * pop-技能培训
   */
  POPTRAIN: 4,
  /**
   * pop-实物商品
   */
  POPENTITY: 5,
  /**
   * pop-到店
   */
  POPSTORE: 6,
  /**
   * pop-到家
   */
  POPHOME: 7,
  /**
   * 景点旅游/门票
   */
  TRAVEL_TICKET: 8,
  /**
   * 在线教育：平台以虚拟商品销售在线教育机构上课资格
   */
  ONLINE_EDU_9: 9,
  /**
   * 联营到家
   */
  UNIONHOME: 10,
  /**
   * 家电洗护
   */
  APPLIANCE_WASHING: 11,
  /**
   * 到店特殊12
   */
  STORE_SPECIAL: 12
}

export const TENCENT_API_KEY = 'QGPBZ-DB4WZ-22YXC-7CODV-JXLSH-JYFOB'

/**
 *  商品销售属性 1:自营 2：联营
 */
export const GOODS_TYPE = {
  own: 1, // 自营
  joint: 2 // 联营
}

export const BAIDU_AK = 'U9GX7iEpS9bg0Ltbh51t5SjCZQn6Q8kz'

export const YES_OR_NO = {
  NO: 0,
  YES: 1
}

/**
 * userGetStatus 用户领券状态 0 未领取 1 已领取
 */
export const COUPON_RECEIVED_STATUS = {
  UN: YES_OR_NO.NO,
  DONE: YES_OR_NO.YES
}

export const RECOVERY_CATEGORY_ID = '101121' // 产康的品类ID
export const NEWBABY_CATEGORY_ID = '101111' //新生儿的品类ID

//新的上传图片地址
export const UPLOAD_URL =
  '//ims.cekid.com/upload/file.do?bizCode=wx_mall-kos&appCode=wx_mall'
